export var BLOCKED_DAY_CLASS = 'blocked-calendar';